<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Formas de organização</b>
            </h3>
            <router-link
              tag="a"
              class="btn btn-primary pull-right"
              to="/cadastros/formas-organizacao-procedimento/novo"
              v-if="hasPermission('usuario.write')"
            >
              <span class="fa fa-plus"></span> Novo
            </router-link>
          </div>
          <div class="box-body">
            <form action @submit.prevent="getDataTable()">
              <div class="row">
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtros.pesquisa"
                    placeholder="Pesquisa: Entre com o nome ou código da forma de organização."
                  />
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <button class="btn btn-default btn-block">
                      <span class="fa fa-filter"></span> Filtrar
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <table class="table table-hover table-bordered table-striped">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Código</th>
                  <th>Nome</th>
                  <th>Subgrupo</th>
                </tr>
              </thead>
              <tbody>
                <router-link
                  tag="tr"
                  :to="'/cadastros/formas-organizacao-procedimento/editar/' + item.id"
                  class="hand"
                  v-for="(item, index) in dataTable.data"
                  :key="index"
                >
                  <td>{{item.id}}</td>
                  <td>{{item.codigo}}</td>
                  <td>{{item.nome}}</td>
                  <td>{{item.subgrupo.nome}}</td>
                </router-link>
              </tbody>
            </table>
            <div class="row">
              <div
                class="col-sm-5"
              >Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
              <div class="col-sm-7" style="text-align:right">
                <laravue-pagination
                  :limit="5"
                  :data="dataTable"
                  v-on:pagination-change-page="getDataTable"
                >
                  <span slot="prev-nav">&lt; Anterior</span>
                  <span slot="next-nav">Próximo &gt;</span>
                </laravue-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios"; // Cliente para requisição http

export default {
  data: () => ({
    filtros: {
      pesquisa: ""
    },
    dataTable: {}
  }),
  mounted() {
	this.filtros.pesquisa = this.$route.query.pesquisa ? this.$route.query.pesquisa : "";
    this.getDataTable();
  },

  methods: {
    getDataTable(page) {
      if (typeof page === "undefined" || typeof page === "object") {
        page = 1;
      }
      this.filtros.page = page;
      this.$router.push({ query: this.filtros });
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;
      axios
        .get(
          `${this.$store.state.serverURI}/api/cadastros/formas-organizacao-procedimento/getAllPaginate`,
          config
        )
        .then(response => {
          this.dataTable = response.data;
        })
        .catch(error => {
          this.$store.commit("throwException", error);
        });
    }
  },
  watch: {},

  components: {}
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?c9ddf41c